export default __webpack_public_path__ + "static/media/SamsungOne-500_v1.0.37f57d4c.ttf";